import { render, staticRenderFns } from "./ModalSendShooting.vue?vue&type=template&id=1007784a&scoped=true"
import script from "./ModalSendShooting.vue?vue&type=script&lang=js"
export * from "./ModalSendShooting.vue?vue&type=script&lang=js"
import style0 from "./ModalSendShooting.vue?vue&type=style&index=0&id=1007784a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1007784a",
  null
  
)

export default component.exports